import React from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const PaymentCancelPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('booking_id');

  const handleTryAgain = () => {
    if (bookingId) {
      navigate(`/checkout/${bookingId}`);
    } else {
      navigate('/locations');
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-12">
      <div className="container mx-auto px-4 max-w-md">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <Card className="card-shadow">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-[hsl(var(--destructive)/0.1)] rounded-full flex items-center justify-center">
                <XCircle className="w-10 h-10 text-[hsl(var(--destructive))]" />
              </div>
              <h1 className="text-2xl font-semibold mb-2">
                {t('payment.cancel.title')}
              </h1>
              <p className="text-[hsl(var(--muted-foreground))] mb-6">
                {t('payment.cancel.message')}
              </p>
              <div className="space-y-3">
                <Button onClick={handleTryAgain} className="w-full" data-testid="payment-cancel-retry-button">
                  {t('payment.cancel.tryAgain')}
                </Button>
                <Link to="/">
                  <Button variant="outline" className="w-full" data-testid="payment-cancel-home-button">
                    {t('payment.cancel.backHome')}
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
